/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.benefits.modals.remove.controllers', [
  'ui.bootstrap'
])

.controller('MembershipBenefitsModalsRemoveController', ['$scope', '$uibModalInstance', 'currentBenefit', function($scope, $uibModalInstance, currentBenefit) {

    $scope.membershipBenefitsModalsRemove = {

      model: {
        name: ''
      },

      errors: [],

      init: function() {
        if (currentBenefit) {
          this.model = currentBenefit;
        }
      },

      hasErrors: function() {
        return (this.errors.length > 0);
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },

      done: function() {
        $uibModalInstance.close(true);
      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      }

    };

    $scope.membershipBenefitsModalsRemove.init();

}]);